<template>
  <v-bottom-navigation class="tw-break-normal" flat width="auto" color="#D3AE37" :elevation="0"
    style="background:transparent">
    <v-btn link to="/">
      <span class="tw-hidden  sm:tw-block ">Home</span>
      <v-icon>mdi-home </v-icon>
    </v-btn>
    <v-btn link to="/games">
      <span class="tw-hidden sm:tw-block">Casino</span>
      <v-icon>mdi-slot-machine </v-icon>
    </v-btn>
    <v-btn link to="/live-games">
      <span class="tw-hidden sm:tw-block">Live Casino</span>
      <v-icon class="tw-rotate-90">mdi-dice-multiple </v-icon>
    </v-btn>
    <v-btn link to="/flipmaster" v-if="isFlipmasterAllowed">
      <span class="tw-hidden sm:tw-block">Flipmaster </span>
      <v-icon class="tw-rotate-90">mdi-poker-chip</v-icon>
    </v-btn>
    <v-btn @click="gotoEsports()">
      <div class="tw-text-[#BFBFBF] tw-hidden sm:tw-block">Community Betting</div>
      <v-icon color="#BFBFBF">mdi-controller-classic</v-icon>
    </v-btn>
    <v-btn link to="/admin/casino-games" v-if="$auth.user && $auth.is_super_admin">
      <span class="tw-hidden sm:tw-block">Admin</span>
      <v-icon>mdi-shield-crown</v-icon>
    </v-btn>
  </v-bottom-navigation>
</template>

<script>
import { mapState } from "vuex";
export default {
  computed: {
    ...mapState("game", ["flipmasterSettings"]),
    isFlipmasterAllowed() {
      if (this.flipmasterSettings.allowed_users?.includes(this.$auth?.user?.id + "")) return true;
      if (this.flipmasterSettings.is_enabled) return true;
      return false;
    }
  },
  methods: {
    gotoEsports() {
      const url =
        process.env.VUE_APP_SERVER_ENV == "prod"
          ? process.env.VUE_APP_2EZ_URL || "https://2ez.bet"
          : "http://localhost:8000";
      window.open(url, "_blank");
    },
  },
};
</script>

<style scoped>
.v-bottom-navigation {
  justify-content: start;
}
</style>
